import React from 'react';
import Routes from './routes';
import { ThemeProvider } from './theme/ThemeContext';
import GlobalImportFailedModal from './components/GlobalImportFailedModal';
import { Toaster } from './components/ui/sonner';
import { useNotificationToasts } from './hooks/useNotificationToasts';

const App = () => {
  // Initialize notification toast listener
  useNotificationToasts();

  return (
    <ThemeProvider>
      <Routes />
      <GlobalImportFailedModal />
      <Toaster />
    </ThemeProvider>
  );
};

export default App;
